
const chartsInit = {
}

// 单个柱子、条形图表option
// params：{type:"图表类型，bar或者line",tip:"tip名称",unit:"单位",title:"图表名称",
//          label:"数值是否显示，bool",toolbox:"工具栏是否显示，bool",max:"最大值是否显示，bool",min:"最小值是否显示，bool",
//          x:"10px",y:"10%",x2:"10px",y2:"10%"(图表位置,string),namefield:"x轴属性名",valuefield:"y轴属性名"
//          data：数据结构 [{"name":"商州区","value":10},{"name":"洛南县","value":20}...}]}
chartsInit.singleBarlineOps  = function(params) {   
    var xdatas = [];
    var ydatas = [];
    //console.log(params.data);
    params.data.forEach(function(item){
        xdatas.push(item[!util.isEmpty(params["namefield"])?params["namefield"] : 'name']);
        ydatas.push(item[!util.isEmpty(params["valuefield"])?params["valuefield"] : 'value']);
    })
        
    return {
        grid: {
            x:  !util.isEmpty(params["x"])?params["x"] : '50px',
            y:  !util.isEmpty(params["y"])?params["x"] : (!util.isEmpty(params["title"]) || params["toolbox"]==true?'40px':'15px'),
            x2: !util.isEmpty(params["x2"])?params["x2"] : '20px',
            y2: !util.isEmpty(params["y2"])?params["y2"] : '35px'
        },
        title : {
            text: params["title"],
            x:'center'
        },
        legend: {              
            show : false,
            data:['chart']
        },
        toolbox: {
            show : params["toolbox"]==true?true:false,
            feature : {
                magicType : {show: true, type: ['line', 'bar']},
            }
        },
        calculable : true,
        xAxis : [
            {
                type : 'category',
                data : xdatas
            }
        ],
        yAxis : [
            {
                type : 'value',
                axisLabel : {
                    formatter: '{value}'+ (!util.isEmpty(params["unit"])?params["unit"]:"")
                }
            }
        ],
        tooltip:{
            trigger: 'axis',
            formatter: function(para){
                return para[0].name + "<br/>" + 
                (!util.isEmpty(params["tip"])?params["tip"] + "：":"") + 
                para[0].value + (!util.isEmpty(params["unit"])?params["unit"]:"");
            },
            textStyle:{
                color:"#fff"
            }
        },
        series : [
            {
                name:"chart",
                type:!util.isEmpty(params["type"])?params["type"]:"bar",
                data:ydatas,                
                itemStyle : { normal: {label : {show: params["label"]==true?true:false}}},
                markPoint : {
                    data : [
                        params["max"]==true?{type : 'max', name: '最大值'}:{},
                        params["min"]==true?{type : 'min', name: '最小值'}:{}
                    ]
                }
            }
        ]
    };
}

// 多个柱子、条形图表option
// params：{type:"图表类型，bar或者line",tip:"tip名称",unit:"单位",title:"图表名称",
//          label:"数值是否显示，bool",toolbox:"工具栏是否显示，bool",max:"最大值是否显示，bool",min:"最小值是否显示，bool",
//          x:"10px",y:"10%",x2:"10px",y2:"10%"(图表位置,string),namefield:"x轴属性名",valuefield:"y轴属性名"
//          data：数据结构数据结构 [{"legend":"种植","datas":[{"name":"商州区","value":10},{"name":"洛南县","value":20}...]},
//               {"legend":"养殖","datas":[{"name":"商州区","value":20},{"name":"洛南县","value":10}...]}]}
chartsInit.multipleBarlineOps  = function(params) { 
    var legends = [];
    var xdatas = [];
    var ydatas = [];
    console.log(params.data);
    params.data.forEach(function(item,index){
        var series = [];
        item.datas.forEach(function(d){
            if(index==0)
            {
                xdatas.push(d["name"]);
            }
            series.push(d["value"]);
        })   
        legends.push(item["legend"]);
        ydatas.push(
        {
            name:item["legend"],
            type:!util.isEmpty(params["type"])?params["type"]:"bar",
            stack:params["tip"],
            itemStyle : { normal: {label : {show: params["label"]==true?true:false}}},
            data:series,
        });
    })
    return  {
        grid: {
            x:  !util.isEmpty(params["x"])?params["x"] : '50px',
            y:  !util.isEmpty(params["y"])?params["y"] : (!util.isEmpty(params["title"]) || params["toolbox"]==true?'70px':'40px'),
            x2: !util.isEmpty(params["x2"])?params["x2"] : '20px',
            y2: !util.isEmpty(params["y2"])?params["y2"] : '35px'
        },
        title : {
            text: params["title"],
            x:'center'
        },
        tooltip : {
            trigger: 'axis',
            formatter: function(para){
                var res = para[0].name;
                for (var i = 0, l = para.length; i < l; i++) {
                    res += '<br/>' + para[i].seriesName + (!util.isEmpty(params["tip"])?params["tip"] :"") + 
                    ' : ' + para[i].value + (!util.isEmpty(params["unit"])?params["unit"] :"") ;
                }
                return res;
            }
        },
        legend: {
            data:legends,
            //y: !util.isEmpty(params["title"])?'40px':'10px'
            y: !util.isEmpty(params["legend"].y)?params["legend"].y:'top',
            x: !util.isEmpty(params["legend"].x)?params["legend"].x:'top',
        },
        toolbox: {
            show : params["toolbox"]==true?true:false,
            feature : {
                magicType : {show: true, type: ['line', 'bar']},
            }
        },
        calculable : true,
        xAxis : [
            {
                type : 'category',
                data : xdatas,
                axisLabel: {
                    textStyle: {
                        fontSize:'14'
                    },
                    rotate: !util.isEmpty(params["rotate"]) ? parseInt(params["rotate"]) : 0
                },
            }
        ],
        yAxis : [
            {
                type : 'value',
                axisLabel : {
                    formatter: '{value}'+ (!util.isEmpty(params["unit"])?params["unit"]:"")
                }
            }
        ],
        series : ydatas
    };
}

// 饼图option
// params：{type:"图表类型，pie或者circle",tip:"tip名称",unit:"单位",title:"图表名称",
//          legend:{orient:"布局方式，horizontal|vertical",x:"水平位置，center|left|right|（x坐标px）",y:"垂直位置，top|bottom|center| （y坐标px）"},
//          radius:"半径,65%",center:['50%', '60%']（中心，数组）,namefield:"x轴属性名",valuefield:"y轴属性名"
//          data：数据结构 [{"name":"商州区","value":10},{"name":"洛南县","value":20}...}]}
chartsInit.pieOps  = function(params) {
    var xdatas = [];
    var ydatas = [];
    params.data.forEach(function(item){
        xdatas.push(item[!util.isEmpty(params["namefield"])?params["namefield"] : 'name']);
        ydatas.push({value:item[!util.isEmpty(params["valuefield"])?params["valuefield"] : 'value'],
        name:item[!util.isEmpty(params["namefield"])?params["namefield"] : 'name']});
    })
    return {
        title : {
            text: params.title,
            x:'center',
            subtext: params.subtext
        },
        tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {d}% ({c}"+(!util.isEmpty(params["unit"])?params["unit"] : "")+")"
        },
        legend: {
            orient : !util.isEmpty(params.legend) && !util.isEmpty(params.legend.orient)?params.legend.orient : 'horizontal',
            x : !util.isEmpty(params.legend) && !util.isEmpty(params.legend.x)?params.legend.x : 'left',
            y : !util.isEmpty(params.legend) && !util.isEmpty(params.legend.y)?params.legend.y : 'top',
            textStyle: {
                align: 'center',
            },
            data:xdatas
        },
        toolbox: {
            show : false,            
        },
        series : [
            {
                name:!util.isEmpty(params["tip"])?params["tip"] : '比例',
                type:'pie',
                itemStyle : {                
                    emphasis : {
                        label : {
                            show : true,
                            position : 'center',
                            textStyle : {
                                fontSize : '16',
                            }
                        },
                    },
                    normal: {
                        labelLine: {
                            show: false,
                            length: 15
                        },
                        label: {
                            show: false,
                        }
                    },
                },
                radius : !util.isEmpty(params["radius"])?params["radius"] : 
                (params["type"] == "pie"? '60%' :  ['45%', '65%']),
                center: !util.isEmpty(params["center"])?params["center"] : ['50%', '50%'],
                data: ydatas
            }
        ]
    };
                        
}

export default chartsInit
